'use strict';
/**
 * Populates measurement fields with length and width options in millimeters.
 *
 * @returns {void}
 */
var fillSelectMillimeters = {
    /**
     * @function
     * @description initialize estimate events
     */

    init: function (sizes) {
        const $fitGuideCalculator = $('.fit-guide-calculator');
        const $fitGuideForm = $fitGuideCalculator.find('.fit-guide-form');
        const $lengthDropdowns = $fitGuideForm.find('select[id^="length"]');
        const $widthDropdowns = $fitGuideForm.find('select[id^="width"]');
        const selectedOption = $fitGuideCalculator.find('.size-options .selected');

        let lengthMinValue;
        let lengthMaxValue;
        let widthMinValue;
        let widthMaxValue;

        if ($.isEmptyObject(sizes)) {
            return;
        }

        if (selectedOption.length > 0) {
            let mainSizing = 'size' + $fitGuideCalculator.data('main-region').toUpperCase();
            for (let i = 0; i <= Object.keys(sizes).length; i++) {
                const currentSizeType = Object.keys(sizes)[i];
                let sizesArray = sizes[currentSizeType];
                if (selectedOption.hasClass(currentSizeType)) {
                    if (selectedOption[0].className.match(/(men|women|kids)/)) {
                        for (let y = 0; y <= Object.keys(sizes[currentSizeType]).length; y++) {
                            const secondarySizeType = Object.keys(sizes[currentSizeType])[y];
                            sizesArray = sizes[currentSizeType];

                            if (selectedOption.hasClass(secondarySizeType)) {
                                sizesArray = sizesArray[secondarySizeType].filter(item => item[mainSizing]);
                            }
                            if (sizesArray[0]) {
                                lengthMinValue = sizesArray[0].lengthNarrow[0];
                                lengthMaxValue = sizesArray[sizesArray.length - 1].lengthRegular[1];
                                widthMinValue = sizesArray[0].widthNarrow[0];
                                widthMaxValue = sizesArray[sizesArray.length - 1].widthRegular[1];
                            }
                        }
                    } else {
                        for (let j in sizesArray) {
                            sizesArray[j] = sizesArray[j].filter(item => item[mainSizing]);
                        }
                        lengthMinValue = sizesArray.women[0].lengthNarrow[0];
                        lengthMaxValue = sizesArray.men[sizesArray.men.length - 1].lengthRegular[1];
                        widthMinValue = sizesArray.women[0].widthNarrow[0];
                        widthMaxValue = sizesArray.men[sizesArray.men.length - 1].widthRegular[1];
                    }
                }
            }
        }

        if ($lengthDropdowns.length > 0) {
            for (let i = lengthMinValue; i <= lengthMaxValue; i++) {
                $lengthDropdowns.append(new Option(i + ' mm', i));
            }
        }

        if ($widthDropdowns.length > 0) {
            for (let i = widthMinValue; i <= widthMaxValue; i++) {
                $widthDropdowns.append(new Option(i + ' mm', i));
            }
        }
    }
};

module.exports = fillSelectMillimeters;
